import { Box, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ShowContainer from './ShowContainer';
import { IconInfoCircle } from '@tabler/icons-react';
import CusTooltip from './CusTooltip';
import CusItemTooltip from './CusItemTooltip';

export default function CusTypographyBox({
  title,
  value,
  titleVariant = 'h6',
  valueVariant = 'body2',
  toolTipTitle,
  valueColor = 'text.secondary',
  textAlign
}) {
  const { t } = useTranslation();
  return (
    <Box>
      <Stack display={'flex'} flexDirection={'row'} alignItems={'center'} gap={1}>
        <Stack>
          <Typography variant={titleVariant} mb={0.5}>
            {t(title)} <CusTooltip text={toolTipTitle} />
          </Typography>
          <Typography variant={valueVariant} color={valueColor} mb={0.5} textAlign={textAlign}>
            {value}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
